var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "29px",
    viewBox: "0 0 27 29",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "shoppingGroup 16")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-520.000000, -1160.000000)",
    stroke: "#1D1D1B",
    strokeWidth: 1.296
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(521.000000, 1161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0186364,16.2685983 L24.3031818,16.2685983 C24.655,16.2685983 24.9431818,16.5582763 24.9431818,16.9129373 L24.9431818,21.2118864 L24.9431818,21.9445475 C24.9431818,24.5832254 22.8181818,26.7230898 20.1968182,26.7230898 C17.5759091,26.7230898 15.4504545,24.5832254 15.4504545,21.9445475 L15.4504545,21.0045814 L15.4504545,0.940835593 C15.4504545,0.586632203 15.1627273,0.29649661 14.8104545,0.29649661 L0.934545455,0.29649661 C0.582727273,0.29649661 0.294545455,0.586632203 0.294545455,0.940835593 L0.294545455,21.2901407 L0.294545455,21.9445475 C0.294545455,24.5832254 2.42,26.7230898 5.04090909,26.7230898 L20.1968182,26.7230898",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.02518182,
    y1: 10.8997627,
    x2: 13.8674545,
    y2: 10.8997627,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.02518182,
    y1: 21.1476356,
    x2: 13.8674545,
    y2: 21.1476356,
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.14077273,
    y1: 15.2662119,
    x2: 11.7516818,
    y2: 15.2662119,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.14077273,
    y1: 17.1413847,
    x2: 11.7516818,
    y2: 17.1413847,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.14077273,
    y1: 4.28091864,
    x2: 11.7516818,
    y2: 4.28091864,
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.14077273,
    y1: 6.15586271,
    x2: 11.7516818,
    y2: 6.15586271,
    id: "Stroke-13"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.20f46a5a.svg";
export { ForwardRef as ReactComponent };